<script setup lang="ts">
import { useRoute } from 'vue-router';
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useChunkError } from '@/composables/useChunkError';

const route = useRoute();
const isError = useChunkError();

const reload = () => {
  const redirect = route.query.redirect as string | undefined;
  window.location.replace(redirect || window.location.pathname);
};

const { t } = useI18n({
  messages: {
    ru: {
      title: 'Приложение обновилось',
      description: 'Обновите страницу, чтобы продолжить работу',
      action: 'Обновить',
    },
    en: {
      title: 'Application updated',
      description: 'Please refresh the page to continue',
      action: 'Reload',
    },
  },
});

// If the page is accessed directly then redirect immediately; otherwise, allow the error message to be read
onMounted(() => {
  if (!isError.value) {
    reload();
  }
});
</script>


<template>
  <VDefaultLayout
    title=""
    :page-title="t('title')">
    <main class="gap-16 flex flex-col self-centered items-center">
      <h1 data-testid="reload-title" class="text-xl font-bold">{{ t('title') }}</h1>
      <p data-testid="reload-description">{{ t('description') }}</p>

      <Button
        data-testid="reload-button"
        :label="t('action')"
        @click="reload"
      />
    </main>
  </VDefaultLayout>
</template>
